/**
 * The Agents pages in the Admin dashboard (docs/pdlc/agents-admin.md), in menu
 * order. The menu in /tools/layout.tsx and each page's own links read this list.
 */

export const AGENTS_FLAG = 'staff-agents';
export const AGENTS_API = '/api/studio/v1/staff/agents';

export interface AgentsPage {
    key: string;
    label: string;
    description: string;
    href: string;
}

export const AGENTS_PAGES: readonly AgentsPage[] = [
    {
        key: 'agents_chat',
        label: 'Chat',
        description:
            'Ask the agents to build and QA surveys, set up fielding, scrub responses and run reports, and share the chats',
        href: '/tools/agents/chat',
    },
    {
        key: 'agents_jobs',
        label: 'Jobs and schedules',
        description: 'Scheduled agent jobs, their runs, and running one now',
        href: '/tools/agents/jobs',
    },
    {
        key: 'agents_usage',
        label: 'Usage',
        description: 'Agent runs, hours saved, adoption and feedback',
        href: '/tools/agents/usage',
    },
    {
        key: 'agents_ooh',
        label: 'OOH campaigns',
        description: 'Campaign pacing, notes, reminder surveys and iOOH setup',
        href: '/tools/agents/ooh',
    },
    {
        key: 'agents_skills',
        label: 'Skills',
        description: 'The Skills agent: write, generate, test and switch skills on',
        href: '/tools/agents/skills',
    },
    {
        key: 'agents_memories',
        label: 'Memories',
        description: 'What the agents remember about you',
        href: '/tools/agents/memories',
    },
    {
        key: 'agents_models',
        label: 'Model config',
        description: 'Which AI model each agent tool uses, how each performs, and model tests',
        href: '/tools/agents/models',
    },
    {
        key: 'agents_release_notes',
        label: 'Release notes',
        description: 'Release notes drafted from Jira: edit, schedule, publish or hide',
        href: '/tools/agents/release-notes',
    },
];
